<template>
  <vs-row class="my-3">
    <vs-col
      v-if="process"
      vs-lg="12"
      class="text-primary d-flex justify-content-between"
    >
      <div class="my-3">
        <b-form-checkbox
          data-cy="select-all"
          class="d-inline-block"
          v-model="selectAll"
          @change="$emit('select-all', selectAll)"
        >
        </b-form-checkbox>
        Seleccionar todos
      </div>
      <b-button
        class="float-right"
        v-if="process && selectedFlows.length"
        data-cy="process-massive-button"
        variant="info"
        size="sm"
        v-on:click="$emit('attempt-process')"
      >
        <feather-icon
          icon="PlayIcon"
          class="mr-50"
        />
        <span class="align-middle">Procesar</span>
      </b-button>
    </vs-col>
    <vs-col vs-lg="12">
      <b-button
        v-show="!process || process === 'approve'"
        class="mr-2"
        data-cy="approve-massive-button"
        variant="success"
        size="sm"
        v-on:click="$emit('massive-process', 'approve')"
      >
        <feather-icon
          icon="CheckIcon"
          class="mr-50"
        />
        <span class="align-middle">Aprobar</span>
      </b-button>
      <b-button
        v-show="!process || process === 'sign'"
        class="mr-2"
        data-cy="sign-massive-button"
        variant="info"
        size="sm"
        v-on:click="$emit('massive-process', 'sign')"
      >
        <feather-icon
          icon="EditIcon"
          class="mr-50"
        />
        <span class="align-middle">Firmar</span>
      </b-button>
      <b-button
        class="mr-2"
        v-show="!process || process === 'reject'"
        data-cy="reject-massive-button"
        variant="danger"
        size="sm"
        v-on:click="$emit('massive-process', 'reject')"
      >
        <feather-icon
          icon="XCircleIcon"
          class="mr-50"
        />
        <span class="align-middle">Rechazar</span>
      </b-button>
      <b-button
        class="mr-2"
        v-show="!process || process === 'assign'"
        data-cy="assign-massive-button"
        variant="primary"
        size="sm"
        v-on:click="$emit('massive-process', 'assign')"
      >
        <feather-icon
          icon="UserCheckIcon"
          class="mr-50"
        />
        <span class="align-middle">Asignar</span>
      </b-button>
      <b-button
        v-if="process"
        data-cy="cancel-massive-button"
        variant="secondary"
        size="sm"
        v-on:click="$emit('cancel')"
      >
        <feather-icon
          icon="XIcon"
          class="mr-50"
        />
        <span class="align-middle">Cancelar</span>
      </b-button>
    </vs-col>
  </vs-row>
</template>
<script>
export default {
  name: 'MassiveActions',
  data() {
    return {
      selectAll: this.value
    };
  },
  watch: {
    selectAll(newValue) {
      this.$emit('input', newValue);
    }
  },
  props: ['value', 'process', 'selectedFlows']
};
</script>
